import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useGoogleMaps } from "../../../../../../utils/mapConfig";
import { Autocomplete } from "@react-google-maps/api";

const FranchForm = ({ open, onClose, franchise, onSubmit, isEdit }) => {
  const { isLoaded } = useGoogleMaps();
  const ownerAutocompleteRef = useRef(null);
  const businessAutocompleteRef = useRef(null);

  const [formState, setFormState] = useState({
    businessName: "",
    place: "",
    mobileNumber: "",
    description: "",
    userName: "",
    userPhone: "",
    userLocation: "",
    userAddress: "",
  });

  useEffect(() => {
    if (franchise) {
      setFormState({
        businessName: franchise.business_title,
        place: franchise.place,
        mobileNumber: franchise.mobile_number,
        description: franchise.description,
      });
    } else {
      setFormState({
        businessName: "",
        place: "",
        mobileNumber: "",
        description: "",
      });
    }
    setErrors({});
  }, [franchise, open]);

  const [errors, setErrors] = useState({});

  const validationForm = () => {
    const newErrors = {};

    if (!formState.businessName)
      newErrors.businessName = "Business Name is required";
    if (!formState.place) newErrors.place = "Business Place is required";
    if (!formState.mobileNumber) {
      newErrors.mobileNumber = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formState.mobileNumber)) {
      newErrors.mobileNumber = "Mobile number must be 10 digits.";
    }
    if (!formState.description)
      newErrors.description = "Description is required";

    if (!franchise) {
      if (!formState.userName) newErrors.userName = "User Name is required";

      if (!formState.userPhone) {
        newErrors.userPhone = "Mobile number is required.";
      } else if (!/^\d{10}$/.test(formState.userPhone)) {
        newErrors.userPhone = "Mobile number must be 10 digits.";
      }
      if (!formState.userLocation)
        newErrors.userLocation = "User Location is required";
      if (!formState.userAddress)
        newErrors.userAddress = "User Address is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validationForm()) {
      onSubmit(formState);
      onClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handlePlaceChanged = (field) => {
    let placeRef =
      field === "userLocation"
        ? ownerAutocompleteRef.current
        : businessAutocompleteRef.current;

    if (placeRef) {
      const place = placeRef.getPlace();
      if (place && place.formatted_address) {
        setFormState((prevState) => ({
          ...prevState,
          [field]: place.formatted_address,
        }));
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ color: "#ff4d4d" }}>
        {franchise ? "Edit Franchisee Details" : "Add Franchisee Details"}
      </DialogTitle>

      <DialogContent>
        {isEdit ? (
          <></>
        ) : (
          <>
            <Typography gutterBottom>Franchisee Owner Details</Typography>
            <TextField
              fullWidth
              label="Owner Name"
              name="userName"
              value={formState.userName}
              onChange={handleChange}
              margin="dense"
              error={!!errors.userName}
              helperText={errors.userName}
            />
            <TextField
              fullWidth
              label="Owner Phone"
              name="userPhone"
              value={formState.userPhone}
              onChange={handleChange}
              margin="dense"
              error={!!errors.userPhone}
              helperText={errors.userPhone}
            />
            {isLoaded && (
              <Autocomplete
                onLoad={(autocomplete) => {
                  ownerAutocompleteRef.current = autocomplete;
                }}
                onPlaceChanged={() => handlePlaceChanged("userLocation")}
              >
                <TextField
                  fullWidth
                  label="Owner Location"
                  name="userLocation"
                  value={formState.userLocation}
                  onChange={handleChange}
                  margin="dense"
                  error={!!errors.userLocation}
                  helperText={errors.userLocation}
                />
              </Autocomplete>
            )}

            <TextField
              fullWidth
              label="Owner Address"
              name="userAddress"
              value={formState.userAddress}
              onChange={handleChange}
              margin="dense"
              multiline
              rows={4}
              error={!!errors.userAddress}
              helperText={errors.userAddress}
            />
          </>
        )}

        <Typography gutterBottom>Business Details</Typography>
        <TextField
          fullWidth
          label="Business Name"
          name="businessName"
          value={formState.businessName}
          onChange={handleChange}
          margin="dense"
          error={!!errors.businessName}
          helperText={errors.businessName}
        />
        {isLoaded && (
          <Autocomplete
            onLoad={(autocomplete) => {
              businessAutocompleteRef.current = autocomplete;
            }}
            onPlaceChanged={() => handlePlaceChanged("place")}
          >
            <TextField
              fullWidth
              label="Business Place"
              name="place"
              value={formState.place}
              onChange={handleChange}
              margin="dense"
              error={!!errors.place}
              helperText={errors.place}
            />
          </Autocomplete>
        )}
        <TextField
          fullWidth
          label="Mobile Number"
          name="mobileNumber"
          value={formState.mobileNumber}
          onChange={handleChange}
          margin="dense"
          error={!!errors.mobileNumber}
          helperText={errors.mobileNumber}
        />
        <TextField
          fullWidth
          label="Business Description"
          name="description"
          value={formState.description}
          onChange={handleChange}
          margin="dense"
          multiline
          rows={4}
          error={!!errors.description}
          helperText={errors.description}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="error"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="success"
          style={{ textTransform: "none" }}
        >
          {franchise ? "Edit" : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FranchForm;
